import React, { useEffect, useState } from "react";
import { useStyles } from "./styles";
import PropTypes from "prop-types";
import { Container, Divider, Typography } from "@material-ui/core";
import { useOccupancyDataContext } from "../DashboardWidget/OccupancyDataProvider";

export const OccupancyAvailabilityMiniPanel = ({ entityId }) => {
  const [totalCount, setTotalCount] = useState(0);
  const [transientCount, setTransientCount] = useState(0);
  const [contractCount, setContractCount] = useState(0);

  const [totalOccupied, setTotalOccupied] = useState(0);
  const [transientOccupied, setTransientOccupied] = useState(0);
  const [contractOccupied, setContractOccupied] = useState(0);

  const {
    countDataLoaded,
    countDataByFacility,
    loadOccupancyDataForFacility
  } = useOccupancyDataContext();

  useEffect(() => {
    if (entityId && !countDataLoaded) {
      loadOccupancyDataForFacility(entityId);
    }
  }, [entityId, countDataLoaded, loadOccupancyDataForFacility]);

  useEffect(() => {
    if (countDataLoaded && entityId && countDataByFacility[entityId]) {
      const occupancyData = countDataByFacility[entityId];

      const facilityData = occupancyData.find(x => x.occupancyType?.toLowerCase() === "facility");
      if (facilityData) {
        setTotalCount(facilityData.totalSpaces);
        setTotalOccupied(facilityData.occupied);
      }

      const transientData = occupancyData.find(x => x.occupancyType?.toLowerCase() === "transient");
      if (transientData) {
        setTransientCount(transientData.totalSpaces);
        setTransientOccupied(transientData.occupied);
      }

      const contractData = occupancyData.find(x => x.occupancyType?.toLowerCase() === "contract");
      if (contractData) {
        setContractCount(contractData.totalSpaces);
        setContractOccupied(contractData.occupied);
      }
    }
  }, [countDataLoaded, countDataByFacility, entityId]);
  const classes = useStyles();
  
  const totalAvailable = totalCount - totalOccupied;
  const contractAvailable = contractCount - contractOccupied;
  const transientAvailable = transientCount - transientOccupied;
  
  return (
    <Container style={{ marginTop: 10, marginBottom: -15 }}>
      <Typography color="primary" className={classes.spacesAvailable}>
        Spaces Available <span style={{ float: "right" }}>{totalAvailable}/{totalCount}</span>
      </Typography>
      <Divider></Divider>
      <div>
        Contract <span style={{ float: "right" }}>{contractAvailable}/{contractCount}</span>
      </div>
      <div>
        Transient <span style={{ float: "right" }}>{transientAvailable}/{transientCount}</span>
      </div>
    </Container>
  );
};

OccupancyAvailabilityMiniPanel.defaultProps = { entityId: undefined };
OccupancyAvailabilityMiniPanel.propTypes = { entityId: PropTypes.string };

export default OccupancyAvailabilityMiniPanel;
